import { render, staticRenderFns } from "./QiniuUpload.vue?vue&type=template&id=83206b6a&scoped=true"
import script from "./QiniuUpload.vue?vue&type=script&lang=js"
export * from "./QiniuUpload.vue?vue&type=script&lang=js"
import style0 from "./QiniuUpload.vue?vue&type=style&index=0&id=83206b6a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83206b6a",
  null
  
)

export default component.exports